import { render, staticRenderFns } from "./SideBySide.vue?vue&type=template&id=a3e3883c&scoped=true&"
import script from "./SideBySide.vue?vue&type=script&lang=ts&"
export * from "./SideBySide.vue?vue&type=script&lang=ts&"
import style0 from "./SideBySide.vue?vue&type=style&index=0&id=a3e3883c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e3883c",
  null
  
)

export default component.exports